if (document.querySelector('form')) {
    // Default options
    const defaultOptions = {
        selectorButtonSubmit: '.form--submit'
    };

    function initializeApplicationForm(formElement, optionsOverwrite = {}) {
        // Merge default options with provided options
        const options = Object.assign({}, defaultOptions, optionsOverwrite);

        const buttonSubmit = formElement.querySelector(options.selectorButtonSubmit);

        // Add event listener for form submission
        formElement.addEventListener('submit', function(e) {
            deactivateSubmitButton(buttonSubmit);
        });
    }

    function deactivateSubmitButton(button) {
        button.disabled = true;
    }

    // Usage
    const form = document.querySelector('form');
    initializeApplicationForm(form);
}

